import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../public/jepBrandingAssets/loading/loadingOwl.gif'

export const LoadingCalculatingImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Loading...'} style={{ objectFit: 'contain', width: '100%', height: '100%' }} />
)
